/**
 * WordPress dependencies
 */
import { Modal } from '@safe-wordpress/components';
import { useDispatch, useSelect } from '@safe-wordpress/data';
import { _x, sprintf } from '@safe-wordpress/i18n';

/**
 * Internal dependencies
 */
import './style.scss';
import { store as NAB_EDITOR } from '../../store';

export const AiAlternativeAttributesModal = (): JSX.Element | null => {
	const { alternativeId, alternative } = useSelect( ( select ) => {
		const id = select( NAB_EDITOR ).getAiAlternativeModal();
		if ( ! id ) {
			return { alternativeId: id, alternative: undefined };
		}
		const alt = select( NAB_EDITOR ).getAlternative( id );
		return { alternativeId: id, alternative: alt };
	}, [] );
	const { showAiAlternativeModal } = useDispatch( NAB_EDITOR );

	const attributes = alternative?.ai;
	if ( ! alternativeId || ! attributes || ! attributes.changes.length ) {
		return null;
	}

	const close = () => showAiAlternativeModal( undefined );

	return (
		<Modal
			className="nab-ai-alternative-attributes-modal"
			title={ sprintf(
				/* translators: %s: Nelio AI. */
				_x( '%s – Variant Details', 'text', 'nelio-ab-testing' ),
				'Nelio AI'
			) }
			isDismissible={ true }
			onRequestClose={ close }
			shouldCloseOnClickOutside={ false }
		>
			<p>
				{ sprintf(
					/* translators: %s: Variant name. */
					_x(
						'Apply these AI-recommended changes to “%s” to make it stand out from the control:',
						'user',
						'nelio-ab-testing'
					),
					attributes.name
				) }
			</p>
			<ol>
				{ attributes.changes.map( ( change, index ) => (
					<li key={ index }>{ change }</li>
				) ) }
			</ol>
		</Modal>
	);
};
